module.exports = __webpack_public_path__ + "static/img/prq9.00b0ac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq9.jpg
// module id = QSyM
// module chunks = 2